import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface SubItem {
  id: number;
  label: string;
  route: string | null;
  icon: string | null;
  adminView: string;
  displayOrder: number;
  subItems: SubItem[];
}

export interface MenuItem {
  id: number;
  label: string;
  route: string | null;
  icon: string | null;
  adminView: string;
  displayOrder: number;
  subItems: SubItem[];
}

interface MenuItemsState {
  menuItems: MenuItem[];
}

const initialState: MenuItemsState = {
  menuItems: [],
};

const menuItemsSlice = createSlice({
  name: 'menuItems',
  initialState,
  reducers: {
    setMenuItems: (state, action: PayloadAction<MenuItem[]>) => {
      state.menuItems = action.payload;
    },
    clearMenuItems: (state) => {
      state.menuItems = [];
    },
  },
});

export const { setMenuItems, clearMenuItems } = menuItemsSlice.actions;
export default menuItemsSlice.reducer;
